import { AppState } from '../../types/store';
import {
    ACCEPT_APPLICATION_SUCCESS,
    FETCH_VACANCY_SUCCESS,
    HiringManagerAction,
    NEW_HIRING_MANAGER_VIDEO_SUCCESS,
    REJECT_APPLICATION_SUCCESS
} from './actions';
import { HiringManagerState } from './types';

export const initialState: HiringManagerState = {
    vacancy: undefined
};

export function reducer(state: HiringManagerState = initialState, action: HiringManagerAction): HiringManagerState {
    switch (action.type) {
        case FETCH_VACANCY_SUCCESS:
        case NEW_HIRING_MANAGER_VIDEO_SUCCESS:
            return {
                ...state,
                vacancy: action.payload.data
            };
        case ACCEPT_APPLICATION_SUCCESS:
        case REJECT_APPLICATION_SUCCESS:
            if (state.vacancy) {
                const updatedApplications = state.vacancy.applications.map(application => {
                    if (application.id !== action.payload.data.id) {
                        return application;
                    }
                    return {
                        ...application,
                        ...action.payload.data
                    };
                });
                const newState = {
                    ...state,
                    vacancy: {
                        ...state.vacancy,
                        applications: updatedApplications
                    }
                };
                return newState;
            } else {
                return state;
            }
        default:
            return state;
    }
}

export const getCurrentVacancy = (state: AppState) => state.hiringManager.vacancy;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/reducer.ts